module.exports = __webpack_public_path__ + "static/6-57f7cd2786704fe06f38c59576d45d4a.jpg";